import React from 'react';
import './Warning.scss';
import alert from '../assets/images/alert.png';

const Warning = ({ isOpen, onClose, onConfirm, title, message, showActions = true }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="warning-modal" onClick={(e) => e.stopPropagation()}>
        <button className="warning-modal-close" onClick={onClose}>
          ×
        </button>

        <div className="warning-modal-icon">
          <img src={alert} alt="Alert" />
        </div>

        <h2 className="warning-modal-title">{title}</h2>

        <p className="warning-modal-message">{message}</p>

        {showActions && (
          <div className="warning-modal-actions">
            <button className="warning-modal-button warning-modal-button-cancel" onClick={onClose}>
              Cancel
            </button>

            <button
              className="warning-modal-button warning-modal-button-confirm"
              onClick={onConfirm}
            >
              Yes Proceed
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Warning;
